export enum AddUsersPopupStep {
    AddUsers = 'AddUsers',
    InviteUsers = 'InviteUsers',
}

export enum InviteUsersOptions {
    Invite = 'Invite',
    NotInvite = 'NotInvite',
}
